import React, {Component} from "react";
import {
    View, Image, TouchableOpacity, Platform, ScrollView,
    Alert, Dimensions, TouchableWithoutFeedback
} from 'react-native'
import {icons} from "../theme/icons";
import {appStyles, componentStyles, loginStyles, fillCustomerAddressStyles} from '../theme/styles'
import TextView from "../components/TextView";
import CedarMaps from '@cedarstudios/react-cedarmaps';
import TextInput from "../components/TextInput/TextInput";

const {width, height} = Dimensions.get('window');

const ASPECT_RATIO = width / height;
const LATITUDE = 35.724566;
const LONGITUDE = 51.367788;
const LATITUDE_DELTA = 0.0922;
const LONGITUDE_DELTA = LATITUDE_DELTA * ASPECT_RATIO;

import Button from "../components/Button";
import DialogList from "../components/DialogList";
import {
    areaRequest,
    citiesRequest,
    findAddressRequest,
    createAddressBookRequest,
    editAddressBookRequest
} from "../utils/api";
import Waiting from "../components/Waiting";
import DialogMessage from "../components/DialogMessage";
import {getError} from "../utils/utils";
import {hp, wp} from "../utils/responsive";

var theme = {
    colors: {
        text: 'black',
        error: 'red',
        primary: '#000000cc',
        outlineColor: '#eeeeee',
        placeholder: 'gray'
    }
}
const styles = {
    icon: {
        iconImage: icons['onmappin'],
        iconSize: 0.3,
        iconOffset: [0, -20],
        iconAllowOverlap: false,
    },
};
var geojson = {
    type: 'FeatureCollection',
    features: [{
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [LONGITUDE, LATITUDE]
        },
        properties: {
            title: 'موقعیت انتخابی',
            description: ''
        }
    }]
};
export default class NewAddressBookScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSuccess: false,
            comment: '',
            id: 0,
            infoCity: null,
            messageTitle: '',
            messageContent: '',
            showMessage: false,
            latitude: 0,
            longitude: 0,
            waiting: false,
            region: [LONGITUDE, LATITUDE],
            currentCenter: [LONGITUDE, LATITUDE],
            regionGeo: geojson,
            ready: false,
            showModal: false,
            cityModal: false,
            areaModal: false,
            pelak: '',
            koche: '',
            vahed: '',
            name: '',
            address: '',
            cities: [],
            areas: [],
            selectedCity: null,
            selectedArea: null
        }
        this.inputs = {};

    }

    focusTheField = (prev, next) => {
        this.inputs[prev].blur()

        this.inputs[next].focus();
    }
    _keyExtractor = (item, index) => index.toString();

    renderFavoritRow({item, index}) {
        return <TouchableOpacity style={componentStyles.favoritItem} activeOpacity={0.5}>
            <TextView>{item.title}</TextView>
            <Image source={icons[item.icon]} style={componentStyles.favoritIcon}/>
        </TouchableOpacity>
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, {tintColor: '#31BFCF'}]}/>
                <TextView style={appStyles.toolbarTitle}>محل مورد نظرتان کجاست ؟</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon}/>
                </TouchableOpacity>
            </View>

            <CedarMaps
                logoPosition='top-left'
                containerStyle={{
                    height: '100vh',
                    width: '100%'
                }}
                onMoveEnd={(_, event) => {
                    console.log(event)
                    if (event.target?._easeOptions?.center != null) {
                        if (Array.isArray(event.target._easeOptions.center)) {
                            this.setCenterMap(event.target._easeOptions.center)
                        } else {
                            this.setCenterMap([event.target._easeOptions.center.lng, event.target._easeOptions.center.lat])
                        }
                    } else if (event.lngLat != null) {
                        this.setCenterMap([event.lngLat.lng, event.lngLat.lat])
                    }
                }}
                token='de1f4bf85b1e70f435a36cc27a5a61075793a194'
                center={this.state.currentCenter}
            >
            </CedarMaps>
            <TouchableOpacity
                style={{backgroundColor: 'white', borderRadius: 5, position: 'absolute', right: 5, bottom: 180}}
                onPress={() => {
                    this.getCurrentPosition();
                }}>
                <Image source={icons['target']} style={appStyles.toolbarIcon}/>
            </TouchableOpacity>

            <TouchableOpacity style={{position: 'absolute', alignSelf: 'center', top: hp(95) / 2}} onPress={() => {
                this.onPointClick()
            }}>
                <Image source={icons['onmappin']} style={{width: wp(20), height: wp(20), resizeMode: 'contain'}}/>
            </TouchableOpacity>

            {this.state.showModal && <TouchableWithoutFeedback onPress={() => {
                this.setState({
                    showModal: false
                })
            }}>
                <View style={appStyles.modalMessageAbsolute}>
                    <TouchableWithoutFeedback onPress={() => {

                    }}>
                        <ScrollView contentContainerStyle={[{flex: 1}, appStyles.center]} enableOnAndroid={true}
                                    keyboardShouldPersistTaps='handled'>
                            <View style={appStyles.modalContent}>
                                <Image source={icons['pin']} style={appStyles.toolbarIcon}/>
                                <TextView>مشخصات آدرس منتخب</TextView>
                                <TextInput
                                    placeholder='نام آدرس (خانه پدربزرگ یا ... )'
                                    mode='outlined'
                                    theme={theme}
                                    ref={input => {
                                        this.inputs['name'] = input
                                    }}
                                    returnKeyType={'next'}
                                    onSubmitEditing={() => {
                                        this.focusTheField('name', 'address')
                                    }}
                                    wrapperStyle={{width: wp(90)}}
                                    onChangeText={(text) => {
                                        this.setState({
                                            name: text
                                        })
                                    }}
                                    value={this.state.name}
                                />
                                <TextInput
                                    placeholder='آدرس'
                                    mode='outlined'
                                    theme={theme}
                                    ref={input => {
                                        this.inputs['address'] = input
                                    }}
                                    returnKeyType={'next'}
                                    onSubmitEditing={() => {
                                        this.focusTheField('address', 'comment')
                                    }}
                                    wrapperStyle={{width: wp(90)}}
                                    onChangeText={(text) => {
                                        this.setState({
                                            address: text
                                        })
                                    }}
                                    value={this.state.address}
                                />
                                <TextInput
                                    placeholder='توضیحات'
                                    mode='outlined'
                                    theme={theme}
                                    ref={input => {
                                        this.inputs['comment'] = input
                                    }}
                                    returnKeyType={'next'}
                                    onSubmitEditing={() => {
                                        this.focusTheField('comment', 'koche')
                                    }}
                                    wrapperStyle={{width: wp(90)}}
                                    onChangeText={(text) => {
                                        this.setState({
                                            comment: text
                                        })
                                    }}
                                    value={this.state.comment}
                                />
                                <View style={appStyles.row}>

                                    <TouchableOpacity style={fillCustomerAddressStyles.textMidInput} onPress={() => {
                                        this.setState({
                                            areaModal: true
                                        })
                                    }}>
                                        <TextView>{this.state.selectedArea != null ? this.state.selectedArea.name : 'منطقه'}</TextView>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={fillCustomerAddressStyles.textMidInput} onPress={() => {
                                        this.setState({
                                            cityModal: true
                                        })
                                    }}>
                                        <TextView>{this.state.selectedCity != null ? this.state.selectedCity.name : 'شهر'}</TextView>
                                    </TouchableOpacity>
                                </View>
                                <View style={[appStyles.center, {marginBottom: 15}]}>
                                    <TextInput
                                        placeholder='کوچه'
                                        mode='outlined'
                                        theme={theme}
                                        ref={input => {
                                            this.inputs['koche'] = input
                                        }}
                                        returnKeyType={'next'}
                                        onSubmitEditing={() => {
                                            this.focusTheField('koche', 'pelak')
                                        }}
                                        wrapperStyle={{width: wp(90)}}
                                        onChangeText={(text) => {
                                            this.setState({
                                                koche: text
                                            })
                                        }}
                                        value={this.state.koche}
                                    />
                                    <View style={appStyles.row}>
                                        <TextInput
                                            placeholder='واحد'
                                            inputType='numeric'
                                            mode='outlined'
                                            theme={theme}
                                            ref={input => {
                                                this.inputs['vahed'] = input
                                            }}
                                            returnKeyType={'done'}
                                            onSubmitEditing={() => {

                                            }}
                                            wrapperStyle={{width: wp(42)}}
                                            onChangeText={(text) => {
                                                this.setState({
                                                    vahed: text
                                                })
                                            }}
                                            value={this.state.vahed}
                                        />
                                        <TextInput
                                            placeholder='پلاک'
                                            inputType='numeric'
                                            mode='outlined'
                                            theme={theme}
                                            ref={input => {
                                                this.inputs['pelak'] = input
                                            }}
                                            returnKeyType={'next'}
                                            onSubmitEditing={() => {
                                                this.focusTheField('pelak', 'vahed')
                                            }}
                                            wrapperStyle={{width: wp(42)}}
                                            onChangeText={(text) => {
                                                this.setState({
                                                    pelak: text
                                                })
                                            }}
                                            value={this.state.pelak}
                                        />
                                    </View>
                                </View>
                                <View style={appStyles.rowAround}>
                                    <TouchableOpacity
                                        activeOpacity={0.5}
                                        style={[appStyles.outlineButton, appStyles.midButton]}
                                        onPress={() => {
                                            this.setState({
                                                showModal: false
                                            })
                                        }}>
                                        <TextView style={{color: '#C0C0C0'}}>بستن</TextView>
                                    </TouchableOpacity>
                                    <Button
                                        text='افزودن'
                                        style={[{
                                            paddingLeft: 20,
                                            paddingRight: 20,
                                            height: 40,
                                            borderRadius: 20,
                                            marginLeft: 20
                                        }, appStyles.midButton]}
                                        textStyle={loginStyles.buttonText}
                                        onPress={() => {
                                            if (this.state.name.length > 0 && this.state.selectedCity != null && this.state.selectedArea != null) {
                                                this.setState({
                                                    waiting: true
                                                })
                                                if (this.state.id == 0) {

                                                    createAddressBookRequest(this.state.name,
                                                        this.state.selectedCity.id,
                                                        this.state.selectedArea != null ? this.state.selectedArea.id : '', this.state.address,
                                                        this.state.koche, this.state.vahed, this.state.pelak, this.state.latitude, this.state.longitude, this.state.comment, (isConnect, response) => {
                                                            this.setState({
                                                                waiting: false
                                                            })
                                                            if (isConnect && response.isSuccess) {
                                                                this.setState({
                                                                    showMessage: true,
                                                                    messageContent: response.message,
                                                                    isSuccess: true
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    showMessage: true,
                                                                    messageContent: getError(response),
                                                                    isSuccess: false
                                                                })
                                                            }
                                                        })
                                                } else {
                                                    editAddressBookRequest(this.state.id, this.state.name,
                                                        this.state.selectedCity.id,
                                                        this.state.selectedArea != null ? this.state.selectedArea.id : '', this.state.address,
                                                        this.state.koche, this.state.vahed, this.state.pelak, this.state.latitude, this.state.longitude, this.state.comment, (isConnect, response) => {
                                                            this.setState({
                                                                waiting: false
                                                            })
                                                            if (isConnect && response.isSuccess) {
                                                                this.setState({
                                                                    showMessage: true,
                                                                    messageContent: response.message,
                                                                    isSuccess: true
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    showMessage: true,
                                                                    messageContent: getError(response),
                                                                    isSuccess: false
                                                                })
                                                            }
                                                        })
                                                }
                                            }
                                        }}
                                    />
                                </View>
                                <Waiting waiting={this.state.waiting}/>
                            </View>
                        </ScrollView>
                    </TouchableWithoutFeedback>
                </View>
            </TouchableWithoutFeedback>}
            <DialogList
                show={this.state.cityModal}
                title='انتخاب شهر'
                field='name'
                data={this.state.cities}
                onSelect={(item, index) => {
                    this.setState({
                        cityModal: false,
                        selectedCity: item,
                    })
                    areaRequest(item.id, (isConnect, response) => {
                        if (isConnect && response.isSuccess) {
                            this.setState({
                                areas: response.data
                            })
                        }
                    })

                }}
                onCancel={() => {
                    this.setState({
                        cityModal: false
                    })
                }}/>
            <DialogList
                show={this.state.areaModal}
                title='انتخاب منطقه'
                field='name'
                data={this.state.areas}
                onSelect={(item, index) => {
                    this.setState({
                        areaModal: false,
                        selectedArea: item,
                    })

                }}
                onCancel={() => {
                    this.setState({
                        areaModal: false
                    })
                }}/>


            <DialogMessage
                show={this.state.showMessage}
                title={this.state.messageTitle}
                message={this.state.messageContent}
                onClose={() => {
                    this.setState({
                        showMessage: false
                    }, () => {
                        if (this.state.isSuccess) {
                            this.props.route.params.refresh();
                            this.props.navigation.goBack()
                        }
                    })


                }}/>
            <Waiting waiting={this.state.waiting}/>
        </View>)
    }

    onPress(event) {
        const {geometry, properties} = event;
        this.setState({
            waiting: true
        })
        var lat = geometry.coordinates[1];
        var lng = geometry.coordinates[0];
        var currentGeo = geojson;
        currentGeo.features[0].geometry.coordinates = geometry.coordinates;
        findAddressRequest(lat, lng, (isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    region: [lng, lat],
                    regionGeo: currentGeo,
                    latitude: lat,
                    showModal: true,
                    address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                    longitude: lng,
                    screenPointX: properties.screenPointX,
                    screenPointY: properties.screenPointY,
                });
            }
        })

    }

    onPointClick() {
        this.setState({
            waiting: true
        })
        var lat = this.state.currentCenter[1];
        var lng = this.state.currentCenter[0];

        findAddressRequest(lat, lng, (isConnect, response) => {
            this.setState({
                waiting: false,

            })
            if (isConnect && response.isSuccess) {
                var city = null;
                var area = null;
                console.log(response.data)
                if (response.data.infocity != null) {
                    city = {
                        id: response.data.infocity.cityid,
                        name: response.data.infocity.cityname
                    }

                    area = {
                        id: response.data.infocity.areaid,
                        name: response.data.infocity.areaname,
                        number: response.data.infocity.areanumber
                    }
                }
                console.log(city)
                this.setState({
                    region: [lng, lat],
                    // regionGeo: currentGeo,
                    selectedCity: city,
                    selectedArea: area,
                    latitude: lat,
                    showModal: true,
                    infoCity: response.data.infoCity,
                    address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                    longitude: lng,
                });
            }
        })
    }


    componentWillMount() {
        citiesRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    cities: response.data
                })
            }
        })
        if (this.props.route.params.id === 0) {
            this.getCurrentPosition()

        } else {
            var data = this.props.route.params.data;
            var currentGeo = geojson;
            currentGeo.features[0].geometry.coordinates = [data.lng, data.lat];
            this.setState({
                region: [data.lng, data.lat],
                regionGeo: currentGeo,
                latitude: data.lat,
                id: data.id,
                address: data.address,
                longitude: data.lng,
                name: data.nameaddress
            });
        }

    }

    setCenterMap(latlng) {
        this.setState({
            currentCenter: latlng,

        })
    }

    getCurrentPosition() {
        this.setState({
            waiting: true
        })
        try {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log(position)
                    var currentGeo = geojson;
                    currentGeo.features[0].geometry.coordinates = [position.coords.longitude, position.coords.latitude];
                    findAddressRequest(position.coords.latitude, position.coords.longitude, (isConnect, response) => {
                        this.setState({
                            waiting: false
                        })
                        if (isConnect && response.isSuccess) {
                            this.setState({
                                region: [position.coords.longitude, position.coords.latitude],
                                regionGeo: currentGeo,
                                latitude: position.coords.latitude,
                                address: response.data.infoaddress.province + ' , ' + response.data.infoaddress.city + ' , ' + response.data.infoaddress.address,
                                longitude: position.coords.longitude,
                            });
                        }
                    })


                },
                (error) => {
                    this.setState({
                        waiting: false,
                        switchValue: false
                    })
                    console.log(error)
                    switch (error.code) {
                        case 1:
                            if (Platform.OS === "ios") {
                                Alert.alert("", "برای تعیین موقعیت مکانی خود، اجازه استفاده از برنامه را در تنظیمات - حریم خصوصی - موقعیت مکانی را فعال کنید");
                            } else {
                                Alert.alert("", "برای تعیین موقعیت مکانی خود، اجازه استفاده از برنامه را در تنظیمات - Apps - AsanDarman - Location را فعال کنید");
                            }
                            break;
                        default:
                            Alert.alert("", "خطا در تشخیص موقعیت مکانی ! لطفا مجددا سعی نمایید");
                    }
                }, {enableHighAccuracy: true, timeout: 30000, maximumAge: 30000}
            );
        } catch (e) {
            alert(e.message || "");
        }
    };

}
